import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function postUserLogout() {
  try {
    const res = await fetch(`${BACKEND_URL}/user/logout`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });

    const ct = res.headers.get("content-type") || "";
    const data = ct.includes("application/json")
      ? await res.json().catch(() => null)
      : null;

    if (!res.ok) {
      if (!data) return { success: false, message: `HTTP_${res.status}` };
      return {
        ...data,
        ...normalizeApiMessage(data, `HTTP_${res.status}`),
      };
    }

    if (!data) return null;
    return {
      ...data,
      ...normalizeApiMessage(data),
    };
  } catch (err) {
    console.error("postUserLogout failed:", err);
    return {
      success: false,
      message: "Network error",
      messageKey: "api.common.networkError",
    };
  }
}
